enum FitAssistantStatus {
  NoSelection = 'noselection',
  Confirmed = 'confirmed',
  ConfirmedNoRacks = 'confirmednoracks',
  Unconfirmed = 'unconfirmed',
  NoFit = 'nofit',
  RackMounting = 'rackmounting',
}

export default FitAssistantStatus;
